// store/Plans/PlansAPI.js
import Axios from "../../utils/axios";
import { authFetch } from "../../utils/authTokenService";

const appendDefaultRequestFields = (params, url) => {
  params.append("mobile", "false");

  if (!["language/read", "language/list"].includes(url)) {
    const language = localStorage.getItem("language_preferred") || "en";
    params.append("language_code", language);
  }
};

const postFormData = async (url, payload = {}) => {
  const params = new URLSearchParams();
  appendDefaultRequestFields(params, url);

  Object.entries(payload || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.append(key, String(value));
    }
  });

  const response = await authFetch(`${process.env.REACT_APP_BASE_URL}${url}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      accept: "application/json",
    },
    body: params.toString(),
  });

  if (!response.ok) {
    let errorMessage = "Request failed";
    try {
      const err = await response.json();
      errorMessage = err?.message || errorMessage;
    } catch (_) {}
    throw new Error(errorMessage);
  }

  return await response.json();
};

export const savePlanAPI = async (payload) => {
  const response = await Axios.post("/plans/save", payload);
  return response.data;
};

export const updatePlanAPI = async (payload) => {
  const response = await Axios.post("/plans/update", payload);
  return response.data;
};

export const readPlanAPI = async (payload = {}) => {
  return await postFormData("plans/read", payload);
};

export const saveDayPlanAPI = async (payload) => {
  return await postFormData("plans/dayplans/save", payload);
};

export const updateDayPlanAPI = async (payload) => {
  return await postFormData("plans/dayplans/update", payload);
};

export const updateDayPlanProgressAPI = async (payload) => {
  return await postFormData("planconsumptions/dayplans/progress/update", payload);
};

export const deleteDayPlanAPI = async (payload) => {
  return await postFormData("plans/dayplans/delete", payload);
};

export const saveDayPlanDetailsAPI = async (payload) => {
  return await postFormData("plans/dayplans/details/save", payload);
};

export const updateDayPlanDetailsAPI = async (payload) => {
  return await postFormData("plans/dayplans/details/update", payload);
};

export const deleteDayPlanDetailsAPI = async (payload) => {
  return await postFormData("plans/dayplans/details/delete", payload);
};

export const createYoutubePlanAPI = async (payload = {}) => {
  const params = new URLSearchParams();

  if (payload?.youtubelink) params.append("youtubelink", payload.youtubelink);
  if (payload?.planName) params.append("planName", payload.planName);
  if (payload?.planThumbnailUrl) {
    params.append("planThumbnailUrl", payload.planThumbnailUrl);
  }

  if (payload?.churchObjId) params.append("churchObjId", payload.churchObjId);
  if (payload?.channelObjId) params.append("channelObjId", payload.channelObjId);
  if (payload?.ministriesObjId) {
    params.append("ministriesObjId", payload.ministriesObjId);
  }
  if (payload?.fcmToken) params.append("fcmToken", payload.fcmToken);

  const response = await authFetch(`${process.env.REACT_APP_BASE_URL}youtubeplans`, {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      accept: "application/json",
    },
    body: params.toString(),
  });

  if (!response.ok) {
    let errorMessage = "Failed to create YouTube plan";
    try {
      const err = await response.json();
      errorMessage = err?.message || errorMessage;
    } catch (_) {}
    throw new Error(errorMessage);
  }

  return await response.json();
};

export const readUserPlansAPI = async () => {
  const response = await authFetch(`${process.env.REACT_APP_BASE_URL}plans/userplans`, {
    method: "POST",
    headers: {
      accept: "application/json",
    },
  });

  if (!response.ok) {
    let errorMessage = "Failed to read user plans";
    try {
      const err = await response.json();
      errorMessage = err?.message || errorMessage;
    } catch (_) {}
    throw new Error(errorMessage);
  }

  return await response.json();
};

export const readFollowedEntityPlansAPI = async () => {
  const response = await authFetch(
    `${process.env.REACT_APP_BASE_URL}plans/followedentities`,
    {
      method: "POST",
      headers: {
        accept: "application/json",
      },
    }
  );

  if (!response.ok) {
    let errorMessage = "Failed to read followed entity plans";
    try {
      const err = await response.json();
      errorMessage = err?.message || errorMessage;
    } catch (_) {}
    throw new Error(errorMessage);
  }

  return await response.json();
};

export const readUserSermonStudyJobsAPI = async (payload = {}) => {
  return await postFormData("sermon-studies/userjobs", payload);
};

export const resetSermonStudyRetryAPI = async (jobId) => {
  if (!jobId) {
    throw new Error("Sermon study job ID is required");
  }

  return await postFormData(`sermon-studies/${jobId}/reset-retry`);
};
